import React from 'react';
import PropTypes from 'prop-types';
import Reactable from 'reactable';
import classnames from 'classnames';
import { getColumns } from '../constants';
import Item from '../components/Item';
import * as shapes from '../shapes';
import { t } from '../../../../../modules/infra/i18n';

const Table = Reactable.Table;
const Thead = Reactable.Thead;
const Th = Reactable.Th;

const List = ({ items, onClick }) => {
  const columns = getColumns();
  
  if (!items.length) {
    return (
      <div className="c-heading c-heading--small u-mt" display-if={!items.length}>
        {t('customers:marketing_leads.no_channels_message')}
      </div>
    );
  }

  return (
    <Table
      className="c-table c-table-new c-table--fixed"
      display-if={items.length}
      sortable
      defaultSort={{ column: 'name', direction: 'asc' }}
    >
      <Thead>
        {columns.map((column, idx) => (
          <Th className={classnames('c-table__th', { 'u-text-left': idx === 0 })} column={column.key} key={column}>
            {column.label}
          </Th>
        ))}
      </Thead>

      {items.map(item => Item({ item, onClick }))}
    </Table>
  );
};
List.propTypes = {
  onClick: PropTypes.func.isRequired,
  items: shapes.items.isRequired,
};
List.defaultProps = {
};

export default List;
